import EmblaCarousel from 'embla-carousel';

export function initStoriesSlider() {
    const viewportEl = document.querySelector('.js-stories-slider');

    if (!viewportEl) return;

    const embla = EmblaCarousel(viewportEl, {
        loop: false,
        align: 'start',
        containScroll: 'trimSnaps',
    });

    const prevBtn = document.querySelector('.c_swiper-storiesblock-prev');
    const nextBtn = document.querySelector('.c_swiper-storiesblock-next');

    if (prevBtn) prevBtn.addEventListener('click', () => embla.scrollPrev());
    if (nextBtn) nextBtn.addEventListener('click', () => embla.scrollNext());

    const paginationEl = document.querySelector('.swiper-stories-pagination');
    if (paginationEl) {
        const dots = embla.scrollSnapList().map((_, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
            dot.className = 'swiper-pagination-bullet';
            dot.addEventListener('click', () => embla.scrollTo(i));
            paginationEl.appendChild(dot);
            return dot;
        });

        function updateDots() {
            const selected = embla.selectedScrollSnap();
            dots.forEach((dot, i) => {
                dot.classList.toggle('swiper-pagination-bullet-active', i === selected);
            });
        }

        embla.on('select', updateDots);
        updateDots();
    }

    function updateNavButtons() {
        if (prevBtn) prevBtn.classList.toggle('swiper-button-disabled', !embla.canScrollPrev());
        if (nextBtn) nextBtn.classList.toggle('swiper-button-disabled', !embla.canScrollNext());
    }

    embla.on('select', updateNavButtons);
    updateNavButtons();
}

